<p-panelMenu [model]="sidebarService.menuTreeItemsChanges | async" [multiple]="false" ></p-panelMenu>
